<template>
  <div>
    <el-divider>{{ title }}</el-divider>
    <biz-type-wrapper label="标题类型">
      <template #biz-type>
        <biz-type-selector v-model="typeProxy" />
      </template>
<!--      <template v-if="hasParent && existPossibleParent" #relation-cell>-->
<!--        <common-selector v-model="parentProxy" :data-source="parentSource" />-->
<!--      </template>-->
    </biz-type-wrapper>
    <template-item v-if="false" label="标题方向">
      <common-chooser :data-source="directions" v-model="directionProxy" />
    </template-item>
    <title-type-selector
      v-if="!sameBizType"
      :type="type"
      :value.sync="bizValueProxy"
      :parent-value="parentValue"
      :mode="inputMode"
      @change-title="emitChangeDisplayText"
    />
<!--    <template-item layout="flex" label="标题文本">-->
<!--      <el-input size="mini" v-model="titleProxy" />-->
<!--    </template-item>-->
  </div>
</template>

<script>
import { Switch, Button, Icon, Divider, Input } from "element-ui";
import {
  findModeChooser,
  findParent,
  maybeChild,
} from "@/components/excel/schema/label/type";
import TemplateItem from "@/components/excel/designer/template/TemplateItem";
import CommonChooser from "@/components/selector/CommonChooser";
import BizTypeWrapper from "@/components/excel/designer/configure/value/biz-type-wrapper";
import BizTypeSelector from "@/components/excel/designer/configure/value/biz-type-selector";
import CommonSingleSelector from "@/components/selector/CommonSingleSelector";
import { Direction } from "@/components/excel/schema/label/direction";
import { toExcelColumnLabel } from "@/utils/excel/ColumnConfig";
import TitleTypeSelector from "@/components/excel/designer/configure/label/TitleTypeSelector";
import { CellPosition } from "@/components/excel/schema/BaseSchema";
import { OtherOption } from "@/components/excel/schema/label/type/other";
import { TextInput } from "@/components/excel/schema/label/mode";

function numberToPosition(digit) {
  if (digit === undefined || digit === null) {
    return null;
  }
  const columnIndex = digit % 10000;
  const rowIndex = (digit - columnIndex) / 10000;
  return new CellPosition(rowIndex, columnIndex);
}
function positionToNumber(position) {
  if (position === undefined || position === null) {
    return null;
  }
  const { rowIndex, columnIndex } = position;
  return rowIndex * 10000 + columnIndex;
}
export default {
  name: "label-configure",
  components: {
    TitleTypeSelector,
    CommonSingleSelector,
    BizTypeSelector,
    BizTypeWrapper,
    CommonChooser,
    TemplateItem,
    [Switch.name]: Switch,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Divider.name]: Divider,
    [Input.name]: Input,
  },
  props: {
    title: {
      type: String,
    },
    displayText: {
      type: String,
    },
    type: {
      type: Number,
    },
    inputMode: {
      type: Number,
    },
    sameBizType: {
      type: Boolean,
    },
    selectTitle: {
      type: Boolean,
    },
    bizValue: {
      type: [Array, String, Number],
    },
    direction: {
      type: Number,
      default: Direction.default,
    },
    parent: {
      type: Object,
    },
    parentValue: {
      type: [Array, Number],
    },
    loadParent: Function,
    allowParent: Boolean,
  },
  computed: {
    hasMode() {
      const { inputMode } = this;
      return inputMode !== null && inputMode !== undefined;
    },
    directionProxy: {
      get() {
        return this.direction;
      },
      set(value) {
        this.emitChangeDirection(value);
      },
    },
    typeProxy: {
      get() {
        return this.$props.type;
      },
      set(value) {
        this.emitChangeType(value);
        this.emitChangeBizValue(null);
      },
    },
    inputModeProxy: {
      get() {
        return this.$props.inputMode;
      },
      set(value) {
        this.emitChangeInputMode(value);
      },
    },
    parentProxy: {
      get() {
        return positionToNumber(this.$props.parent);
      },
      set(value) {
        this.emitChangeParent(numberToPosition(value));
      },
    },
    hasParent() {
      return maybeChild(this.type);
    },
    existPossibleParent(){
      return Array.isArray(this.parentSource) && this.parentSource.length > 0
    },
    titleProxy: {
      get() {
        return this.$props.displayText;
      },
      set(value) {
        this.emitChangeDisplayText(value);
        if (
          this.type === OtherOption.value &&
          this.inputMode === TextInput.value
        ) {
          this.emitChangeBizValue(value);
        }
      },
    },
    bizValueProxy: {
      get() {
        return this.$props.bizValue;
      },
      set(value) {
        this.emitChangeBizValue(value);
      },
    },
  },
  data() {
    const directions = Direction.options;
    return {
      directions,
      parentSource: [],
      modes: [],
    };
  },
  watch: {
    type(type) {
      this.handleChangeType(type);
    },
  },
  mounted() {
    const { direction, type } = this.$props;
    if (!direction) {
      this.emitChangeDirection(Direction.default);
    }
    if (type) {
      this.handleChangeType(type);
    }
  },
  methods: {
    handleChangeType(type) {
      const chooser = findModeChooser(type);
      console.log(type);
      console.log(chooser);
      this.emitChangeInputMode(chooser.default);
      this.loadParentSource(type);
    },
    async loadParentSource(type) {
      const parentType = await findParent(type);
      if (parentType === undefined || parentType === null) {
        this.parentSource = [];
        return;
      }
      const parentSource = await this.$props.loadParent(type);
      this.parentSource = (parentSource || []).map((it) => {
        const value = positionToNumber(it);
        const text = `${toExcelColumnLabel(it.columnIndex)}${it.rowIndex}`;
        return { value, text };
      });
    },
    emitChangeDirection(value) {
      this.$emit("update:direction", value);
      this.$emit("change-direction", value);
    },
    emitChangeUnique(value) {
      this.$emit("update:unique", value);
      this.$emit("change-unique", value);
    },
    emitChangeType(value) {
      this.$emit("update:type", value);
      this.$emit("change-type", value);
    },
    emitChangeInputMode(value) {
      this.$emit("update:input-mode", value);
      this.$emit("change-input-mode", value);
    },
    emitChangeParent(value) {
      this.$emit("update:parent", value);
      this.$emit("change-parent", value);
    },
    emitChangeDisplayText(value) {
      this.$emit("update:display-text", value);
      this.$emit("change-display-text", value);
    },
    emitChangeBizValue(value) {
      this.$emit("update:biz-value", value);
      this.$emit("change-biz-value", value);
    },
  },
};
</script>
